<template>
  <div class="toastOutlet" aria-live="polite">
    <transition-group name="toast">
      <div v-for="t in toasts" :key="t.id" class="toast">{{ t.message }}</div>
    </transition-group>
  </div>
</template>

<script setup lang="ts">
import { useToast } from '../../composables/useToast'

const { toasts } = useToast()
</script>

<style scoped>
.toastOutlet { position: absolute; left: 50%; bottom: var(--space-6); transform: translateX(-50%); display: flex; flex-direction: column; align-items: center; gap: var(--space-2); pointer-events: none; z-index: 20; }
.toast { background: var(--color-text-primary); color: var(--color-bg-app); font-size: var(--fs-sm); font-weight: var(--fw-medium); padding: var(--space-2) var(--space-4); border-radius: var(--radius-full); box-shadow: var(--shadow-md); white-space: nowrap; }
.toast-enter-active, .toast-leave-active { transition: opacity var(--duration-base) var(--ease-out), transform var(--duration-base) var(--ease-out); }
.toast-enter-from, .toast-leave-to { opacity: 0; transform: translateY(8px); }
</style>
